/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutboundFaxResponseDto
 */
export interface OutboundFaxResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OutboundFaxResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundFaxResponseDto
     */
    vendorFaxId?: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundFaxResponseDto
     */
    fromNumber: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundFaxResponseDto
     */
    toNumber: string;
    /**
     * 
     * @type {string}
     * @memberof OutboundFaxResponseDto
     */
    status: OutboundFaxResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OutboundFaxResponseDto
     */
    headerText?: string;
    /**
     * 
     * @type {Date}
     * @memberof OutboundFaxResponseDto
     */
    submittedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OutboundFaxResponseDto
     */
    completedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OutboundFaxResponseDto
     */
    createdAt: Date;
}


/**
 * @export
 */
export const OutboundFaxResponseDtoStatusEnum = {
    Queued: 'queued',
    Submitted: 'submitted',
    Completed: 'completed',
    Failed: 'failed'
} as const;
export type OutboundFaxResponseDtoStatusEnum = typeof OutboundFaxResponseDtoStatusEnum[keyof typeof OutboundFaxResponseDtoStatusEnum];


/**
 * Check if a given object implements the OutboundFaxResponseDto interface.
 */
export function instanceOfOutboundFaxResponseDto(value: object): value is OutboundFaxResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fromNumber' in value) || value['fromNumber'] === undefined) return false;
    if (!('toNumber' in value) || value['toNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function OutboundFaxResponseDtoFromJSON(json: any): OutboundFaxResponseDto {
    return OutboundFaxResponseDtoFromJSONTyped(json, false);
}

export function OutboundFaxResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundFaxResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'vendorFaxId': json['vendorFaxId'] == null ? undefined : json['vendorFaxId'],
        'fromNumber': json['fromNumber'],
        'toNumber': json['toNumber'],
        'status': json['status'],
        'headerText': json['headerText'] == null ? undefined : json['headerText'],
        'submittedAt': json['submittedAt'] == null ? undefined : (new Date(json['submittedAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function OutboundFaxResponseDtoToJSON(json: any): OutboundFaxResponseDto {
    return OutboundFaxResponseDtoToJSONTyped(json, false);
}

export function OutboundFaxResponseDtoToJSONTyped(value?: OutboundFaxResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'vendorFaxId': value['vendorFaxId'],
        'fromNumber': value['fromNumber'],
        'toNumber': value['toNumber'],
        'status': value['status'],
        'headerText': value['headerText'],
        'submittedAt': value['submittedAt'] == null ? undefined : ((value['submittedAt']).toISOString()),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

